import { defineComponent } from 'vue';
import NavMainItem from '@/components/navigation/NavMainItem.vue';
export default defineComponent({
    name: 'Navigation',
    components: {
        NavMainItem,
    },
    props: {
        navItems: {
            type: Object,
            required: true,
        },
    },
    emits: ['click', 'home'],
    setup(props, { emit }) {
        const onClick = (e, path) => {
            emit('click', e, path);
        };
        const goHome = () => {
            emit('home');
        };
        return {
            onClick,
            goHome,
        };
    },
});
